import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
// 解决导航栏重复点击跳转报错报错
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/index')
    },
    // corp
    {
      path: '/corporations',
      name: 'corporations',
      component: () => import('@/views/corporations')
    },
    {
      path: '/download',
      name: 'download',
      component: () => import('@/views/download')
    },
    // // 隐私政策
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/PrivacyPolicy')
    },
    // // 用户协议
    {
      path: '/termOfservice',
      name: 'termOfservice',
      component: () => import('@/views/userAgreement')
    },
     // 免责说明
     {
       path: '/disclaimer',
       name: 'disclaimer',
       component: () => import('@/views/disclaimer'),
       meta: {
         showHeader: false,
         showFooter: false
       }
     },
    // {
    //   path: '/healthDataSources',
    //   name: 'healthDataSources',
    //   component: () => import('@/views/healthDataSources')
    // },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js